import { ContainerModule } from 'inversify';
import { SelectedListService } from './types/selected-list-service.interface';
import { SelectedListServiceImpl } from './selected-list-service';
import { SelectedListModel } from './types/selected-list-model.interface';
import { SelectedRangeModel } from './types/selected-range-model.interface';
import { SelectedListModelImpl } from './models/selected-list-model';
import { SelectedRangeModelImpl } from './models/selected-range-model';
import { SelectedRangeService } from './types/selected-range-service.interface';
import { SelectedRangeServiceImpl } from './selected-range-service';
export const selected = new ContainerModule((bind) => {
    bind(SelectedListService).to(SelectedListServiceImpl);
    bind(SelectedListModel).to(SelectedListModelImpl);
    bind(SelectedRangeModel).to(SelectedRangeModelImpl);
    bind(SelectedRangeService).to(SelectedRangeServiceImpl);
});
